export const MasterDataNumBadge = ({ value, icon: Icon, color, bg, border }) => (
    <span
      className="inline-flex items-center gap-1.5 px-3 py-1 rounded-lg text-xs font-bold mx-auto"
      style={{ color, background: bg, border }}
    >
      <Icon className="text-[10px]" />
      {value ?? "-"}
    </span>
  );